import useGetEngine from './UseGetEngine';

const useGetFavicon = (): string => {
    const { isAdviesbox, isViisi, isFindesk, isFastlane } = useGetEngine();

    if (isAdviesbox()) {
        return '/logos/favicon-adviesbox.png';
    }

    if (isViisi()) {
        return '/logos/favicon-viisi.svg';
    }

    if (isFindesk()) {
        return '/logos/favicon-findesk.png';
    }

    if (isFastlane()) {
        return '/logos/favicon-fastlane.png';
    }

    return '/logos/favicon-findata-grey.png';
};

export default useGetFavicon;
